import styles from "./learningAdaptiveTestGoToPublisher.module.scss";
import RightArrowIcon from "@icons/rightArrowIcon.svg";

export const LearningAdaptiveTestGoToPublisher = (props: Props) => {
  if (!props.isSponsored) {
    return null;
  }

  const clickPublisherButton = () => props.onPublisherClicked();

  return (
    <a
      href={props.destinationUrl}
      onClick={clickPublisherButton}
      target="_blank"
      className={styles["container"]}
      rel="noreferrer"
    >
      <div className={styles["contentContainer"]}>
        <div className={styles["logoContainer"]}>
          <img src={props.img} alt="logo" loading="lazy" />
        </div>
        <div className={styles["description"]}>{props.publisherText}</div>
        <RightArrowIcon />
      </div>
    </a>
  );
};

interface Props {
  img: string;
  name: string;
  isSponsored: boolean;
  destinationUrl: string;
  onPublisherClicked: () => void;
  publisherText: string;
}
